export default {
    SET_VALIDATION_MESSAGES : 'SET_VALIDATION_MESSAGES',
}